import { SbImageMetadata } from "./getSbImageMetadata.util";
import { StoryblokAsset } from "../../../interfaces/StoryblokAsset.interface";
import { getSbGatsbyImageUrl } from "./getSbGatsbyImageUrl.util";

export const getSbGatsbyImageSrcSetArray = (widths: number[], aspectRatio: number, metadata: SbImageMetadata, asset: StoryblokAsset, quality: number, fitIn: boolean, fitInColour: string, smartCrop: boolean): string[] => {
    return widths.map((currentWidth: number) => {
        const resolution: string = `${currentWidth}w`;
        const currentHeight: number = Math.round(currentWidth / aspectRatio);
        // Workaround for Storyblok has bug when crop with width larger than 4000 (eg: crop 5000 will get 4000)
        // Not to set crop when size is same to source
        const sameToSource: boolean = currentWidth === metadata.width && currentHeight === metadata.height;
        const url: string = getSbGatsbyImageUrl(asset, quality, fitIn, fitInColour, smartCrop, sameToSource ? undefined : currentWidth, sameToSource ? undefined : currentHeight);
        const urlAndResolution: string = `${url} ${resolution}`;
        return urlAndResolution;
    });
}